import { render, staticRenderFns } from "./ModuleFormField.vue?vue&type=template&id=0a2d71f0&"
import script from "./ModuleFormField.vue?vue&type=script&lang=js&"
export * from "./ModuleFormField.vue?vue&type=script&lang=js&"
import style0 from "./ModuleFormField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports